const DefaultNotifySchema =  {

     props : {
         cancelCondition: "",
         insertCheck: "false" ,
         activationRecurisveEmailFrequency: "days",
         printAttachmentSelected: "",
         activationPeriodAmountFieldId: "",
         emailAuthPassword: "",
         messageHtml: "",
         personEmailFieldId: "",
         activationType: "0",
         messageSubject: "",
         title: "",
         instanceCheck: "false",
         activationPeriodAmountLiteral: "",
         activationRecurisveEmailNumber: "1",
         personemailliteral: "",
         cancelScope: "2" ,
         hasHtmlForm: "false",
         cancelAllOthers: "false",
         insertAttachment: "",
         activationPeriodUnitField: "minutes",
         emailEmailAddress: "",
         emailReplyToDisplayName: "",
         emailDisplayName: "",
         cancelType: "",
         personUserGroupId: "",
         insertAttachmentSelected: "",
         activationDateField: "",
         emailReplyToEmailAddress: "",
         roleId: "",
         messageSendEmail: "true",
         emailAuthUsername: "",
         activationPeriodUnitLiteral: "minutes",
         existingInstanceAttachmentSelected: "",
         attentionLevel: "1",
         emailServerId: "",
         activationDateExpression: "",
         personType: "",
         personUserName: "",
         personPositionName: "",
         personPositionId: "",
         personUserId: "",
         activationDate: "",
         printCheck: "",
         printAttachment: "",
         personUserGroupName: "",
         existingInstanceAttachment: ""
     },




    addMissingProps: function (cvNotification) {
        for (let prop in this.props) {
            if (!cvNotification.hasOwnProperty(prop)) {
                cvNotification[prop] = this.props[prop];
            }
        }
    }
}


export default DefaultNotifySchema;